import React, {MouseEventHandler, ReactNode} from "react";
import classNames from 'classnames';
import {Button as XpsButton} from 'xps-react';

export type ButtonKind = 'primary' | 'secondary' | 'tertiary' | 'borderless';

export type ButtonProps = {
    ariaLabel?: string,
    children?: ReactNode,
    className?: string,
    destructive?: boolean,
    disabled?: boolean,
    icon?: 'right' | 'left' | 'none' | 'only',
    iconName?: string,
    id?: string,
    includeRef?: boolean,
    kind?: ButtonKind,
    noPadding?: boolean,
    onClick?: MouseEventHandler,
    padding?: boolean,
    role?: string,
    rounded?: boolean,
    size?: 'large' | 'medium' | 'small',
    style?: any,
    tabIndex?: number,
    type?: 'button' | 'reset' | 'submit',
}

const Button = ({ children, className, kind = 'primary', rounded = false, destructive = false, ...rest }: ButtonProps) => (
    <XpsButton
        className={classNames({ 'button--rounded': rounded }, { 'button--destructive': destructive }, className)}
        kind={kind}
        {...rest}
    >
        {children}
    </XpsButton>
);

export default Button;
